export enum PromptStatus {
  Danger = 'danger',
  Warning = 'warning',
}
